module.exports = __webpack_public_path__ + "images/CC_AW 980 x 685px.png";